import { SELECT_CU_SMELTER, UNSELECT_CU_SMELTER } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case SELECT_CU_SMELTER:
			return [...state, action.payload];
		case UNSELECT_CU_SMELTER: {
			return state.filter((item) => item !== action.payload);
		}
		default:
			return state;
	}
};
